import type { JSONContent } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, CustomComponentBlock } from '../../model';
import { BlockToTiptapConverter } from '../blocks-to-tiptap.converter';

export const convertCustomComponentBlockToTiptap = ((block) => {
  const attrs: Record<string, unknown> = {
    id: block.id,
    component_id: block.component_id,
    preset: block.preset ?? null,
    inputs: block.inputs,
  };

  if (block.width !== null && block.width !== undefined) {
    attrs['width'] = block.width;
  }
  if (block.height !== null && block.height !== undefined) {
    attrs['height'] = block.height;
  }
  if (block.padding !== null && block.padding !== undefined) {
    attrs['padding'] = block.padding;
  }
  if (block.align) {
    attrs['align'] = block.align;
  }
  if (block.show_border === true) {
    attrs['show_border'] = true;
  }

  return { type: 'customComponent', attrs };
}) satisfies BlockToTiptapConverter<CustomComponentBlock>;

export function convertTiptapToCustomComponentBlock(json: JSONContent): CustomComponentBlock {
  const attrs = json.attrs ?? {};

  return {
    id: (attrs['id'] as string) ?? uuid(),
    type: ContentBlockType.CustomComponent,
    component_id: (attrs['component_id'] as string) ?? '',
    inputs: (attrs['inputs'] as Record<string, unknown>) ?? {},
    ...(attrs['preset'] && { preset: attrs['preset'] as string }),
    ...(attrs['width'] !== null && attrs['width'] !== undefined && { width: attrs['width'] as number }),
    ...(attrs['height'] !== null && attrs['height'] !== undefined && { height: attrs['height'] as number }),
    ...(attrs['padding'] !== null && attrs['padding'] !== undefined && { padding: attrs['padding'] as number }),
    ...(attrs['align'] && { align: attrs['align'] as CustomComponentBlock['align'] }),
    ...(attrs['show_border'] === true && { show_border: true }),
  };
}
